<template>
	<div class="dropdown">
		<div class="dropdown__toggle">
			{{ toggleText }}
		</div>
		<ul class="dropdown__menu menu menu--vertical">
			<li v-for="(value, id) in _values" :key="id" class="menu__item">
				<router-link :to="value.route" class="menu__link">{{ value.text }}</router-link>
			</li>
		</ul>
	</div>
</template>

<script>

export default {
	components: {  },

	mounted () {

	},

	data () {
		return {

		}
	},

	props: {
		toggleText: {
			type: String,
			required: true
		},
		values: {
			type: Array,
			required: true
		}
	},

	computed: {
		_values: {
			get () {
				return this.values;
			},
			set(newValue) {
				this.$emit("input", newValue);
			}
		}
	},

	methods: {

	}
}
</script>
<style scoped>
	.dropdown { position: relative; }
	.dropdown__toggle { cursor: pointer; }
	.dropdown__toggle::after { display: inline-block; width: 0; height: 0; margin-left: .255em; vertical-align: .255em; content: ""; border-top: .3em solid; border-right: .3em solid transparent; border-left: .3em solid transparent; }
	.dropdown__menu { display: none; white-space: nowrap; text-transform: none; font-weight: 500; z-index: 9999; margin-top: 15px; position: absolute; top: 100%; border-radius: 5px; list-style: none; background: #fff; padding: 20px; box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.2); }
	.dropdown__menu::before { content: " "; width: 0px; height: 0px; position: absolute; top: -10px; border-bottom: 10px solid white; border-left: 10px solid transparent; border-right: 10px solid transparent; box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.2); }
	.dropdown__menu::after { content: " "; width: 100%; height: 15px; position: absolute; left: 0; top: 0; margin-top: -15px; }
	.dropdown:hover .dropdown__menu { display: flex; }
</style>
